import animals  from "./images/animals.png"
import petHouse from "./images/pet-house.png"
import donationImg  from "./images/donation_img.png"
import donationBtnImg from "./images/donation_btn.png"
import facebook from "./images/facebook.png";
import google from "./images/google.png";
import twitter from "./images/twitter.png";
import hector from "./images/hector.png";
import pluto  from "./images/pluto.png";
import pihu from "./images/pihu.png";
import robin from "./images/robin.png";
import gracie from "./images/gracie.png";
import patch from "./images/patch.png";
import vectorBlue from "./images/vectorBlue.png"
import vectorOlive from "./images/vectorOlive.png"
import vectorPink from "./images/vectorPink.png"
import vectorPeach from "./images/vectorPeach.png"
import vectorVoilet from "./images/vectorVoilet.png"
import footprints from "./images/footprints.png"
import saifali from "./images/saifali.png"
import cat from "./images/cat.jpg"
import IT from "./images/IT.jpg"
import connect from "./images/connect.jpg"
import difference from "./images/difference.jpg"
import work from "./images/work.jpg"
import QR_Code from "./images/QR_code.jpg"
import supportpet from "./images/supportpet.jpg"
import supportThanks from "./images/supportThanks.jpg"
import hungryCat from "./images/hungryCat.jpg"
import dog_house from "./images/dog-house.png"
import petParentImg from "./images/petParent.png"
import petAdopterImg from "./images/petAdopter.png"





const images = {
     animals,
     petHouse,
     donationImg,
     donationBtnImg,
     facebook,
     google,
     twitter,
     hector,
     pluto,
     pihu,
     robin,
     gracie,
     patch,
     vectorBlue,
     vectorOlive,
     vectorPink,
     vectorPeach,
     vectorVoilet,
     footprints,
     saifali,
     cat,
     IT,
     connect,
     difference,
     work,
     QR_Code,
     supportpet,
     supportThanks,
     hungryCat,
     dog_house,
     petParentImg,
     petAdopterImg,

     
}
export default images;



